// Baked into the bundle by the pipeline (see azure-pipelines.yml); .env.development supplies a
// local value. Empty when nothing sets it, e.g. in tests.
export function getAppVersionToDisplay(): string {
  return process.env.REACT_APP_VERSION_TO_DISPLAY ?? '';
}
